// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"e55c3775","511":"10d80934","767":"dee0472a"}[chunkId] + ".chunk.js";
};